<template>
  <div class="columadd">
    <el-form ref="AddForm" :model="AddForm" label-width="110px" style="margin-top:10px;margin-bottom:60px;" :rules="AddRules">
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="名称" prop="c_name">
                <el-input v-model="AddForm.c_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="简介" prop="c_introduce">
                <el-input type="textarea" v-model="AddForm.c_introduce" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="状态" prop="c_status">
                <el-radio v-model="AddForm.c_status" label="0">未发布</el-radio>
                <el-radio v-model="AddForm.c_status" label="1">已发布</el-radio>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="代码" prop="c_code">
                <el-input v-model="AddForm.c_code"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="7">
            <el-form-item label="类型" prop="c_type">
                <el-radio v-model="AddForm.c_type" label="0">资讯</el-radio>
                <el-radio v-model="AddForm.c_type" label="1">活动</el-radio>
                <el-radio v-model="AddForm.c_type" label="2">攻略</el-radio>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="是否有子栏目" prop="c_haschild">
                <el-radio v-model="AddForm.c_haschild" label="0">否</el-radio>
                <el-radio v-model="AddForm.c_haschild" label="1">是</el-radio>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="页面" prop="c_single">
                <el-radio v-model="AddForm.c_single" label="0">单页面</el-radio>
                <el-radio v-model="AddForm.c_single" label="1">列表</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="专题" prop="c_topic">
                <el-select v-model="AddForm.c_topic" placeholder="请选择">
                <el-option
                    v-for="item in topicOptions"
                    :key="item.t_id"
                    :label="item.t_name"
                    :value="item.t_id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="所属栏目" prop="c_fid">
                <el-cascader
                    v-model="selectedAddOptions"
                    clearable
                    change-on-select
                    :options="parentAddOptions"
                    @focus="getAddCategory"
                    @change="onProvincesAddChange"
                    :props="parentAddProps"
                    placeholder="此项不选择表示建立顶级栏目"
                    >
                </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="栏目负责人" prop="c_director">
                <el-select v-model="AddForm.c_director" multiple placeholder="请选择">
                <el-option
                    v-for="item in selectAdminOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="排序值" prop="c_sort">
                <el-input v-model="AddForm.c_sort"></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="7">
            <el-form-item label="代码" prop="c_code">
                <el-input v-model="AddForm.c_code"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="链接" prop="c_url">
                <el-input v-model="AddForm.c_url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="图标" prop="c_icon">
            <el-upload
                :class="{disabled:uploadDisabledIcon}"
                :action="uploadAddress"
                list-type="picture-card"
                name="file"
                :limit="1"
                ref="AddUploadIcon"
                :before-upload="beforeUploadIcon"
                :on-preview="handleAddPreviewIcon"
                :http-request="customUploadIcon"
                :on-remove="removeAddUploadIcon"
                :file-list="AddFileListIcon">
                <i class="el-icon-plus"></i>
            </el-upload>
            <!-- :on-success="successAddUploadIcon" -->
            <p style="margin:0;color:red">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
            <el-dialog :visible.sync="AddPreviewDialogVisibleIcon">
              <img width="100%" :src="AddPreviewDialogImageUrlIcon" alt="">
            </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="封面图" prop="c_cover">
            <el-upload
                :class="{disabled:uploadDisabledCover}"
                :action="uploadAddress"
                list-type="picture-card"
                name="file"
                :limit="1"
                ref="AddUpload"
                :http-request="customUploadCover"
                :before-upload="beforeUploadCover"
                :on-preview="handleAddPreviewCover"
                :on-remove="removeAddUploadCover"
                :file-list="AddFileListCover">
                <i class="el-icon-plus"></i>
            </el-upload>
                <!-- :on-success="successAddUploadCover" -->
            <p style="margin:0;color:red">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
                <el-dialog :visible.sync="AddPreviewDialogVisibleCover">
                  <img width="100%" :src="AddPreviewDialogImageUrlCover" alt="">
                </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>   
      </el-form>

      <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
        <el-button type="primary" @click="AddSave('AddForm')" size="small" icon="el-icon-edit-outline">保存</el-button>
      </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
  name: 'componentspage1',
  data() {
      return {
          AddForm : {
              // c_haschild : '',
              c_name : '',
              c_type : '',
              c_amount : '',
              c_id : '',
              c_director : [],
              c_article : '',
              c_single : '',
              c_fid : '',
              // c_sort : '',
              c_sub : '',
              c_topic : '',
              c_url : '',
              c_code : '',
              c_status : '',
              c_level : '',
              c_route : '',
              c_icon : '',
              c_cover : '',
              c_introduce: ''
            },
            
            AddRules : {
              c_name : [{required: true,message : '请输入名称', trigger: 'blur'}],
              c_topic : [{required: true,message : '请选择专题', trigger: 'change'}],
            //   c_fid : [{required: true,message : '请输入所属栏目', trigger: 'blur'}],
              c_single : [{required: true,message : '请选择页面类型', trigger: 'change'}],
          },
            
            AddFileListIcon : [],
            AddFileListCover : [],

            selectAdminOptions : [], // 栏目负责人
            topicOptions : [] , // 专题数组，遍历后可获取专题ID
            parentAddOptions : [] , // 父级选择框
            parentAddProps : {
              value: 'c_id',
              label:'c_name',
              children: 'c_children'
            },

            selectedAddOptions : [],

            uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址

            AddPreviewDialogVisibleCover : false,
            AddPreviewDialogImageUrlCover : '',
            AddPreviewDialogVisibleIcon : false,
            AddPreviewDialogImageUrlIcon : '',
      }
  },
  methods : {
      goBack() {
        this.$router.back(-1);
      },
      // 获取所有专题
      getAllTopic() {
          this.$http.get(`${api.dev}/p/main/drop/selectTopic`,{params : {access_token : getToken()}}).then(res => {
              if(res.body.code == 200) {
                //   this.topicMsg = res.body.content;
                  this.topicOptions = res.body.content;
              }else if(res.body.code == 500) {
                  this.$message({
                    message: res.body.msg,
                    type: 'error'
                  });
                  removeToken();
                  setTimeout(function () {
                    this.$router.push({path: '/login'});
                  },2000)
              }
          })
      },
      // 获取栏目负责人
      getSelectAdmin() {
        this.$http.get(`${api.dev}/p/main/drop/selectAdmin`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200) {
            this.selectAdminOptions = res.body.content;
          }else if(res.body.code == 500) {
            this.$message({
              message: res.body.msg,
              type: 'error'
            });
            removeToken();
            setTimeout(function () {
              this.$router.push({path: '/login'});
            },2000)
          }
        })
      },
      getAddCategory(e) {
        this.$http.get(`${api.dev}/p/main/category/show`,{params: {access_token:getToken(),c_topic:this.AddForm.c_topic}}).then(res => {
            if(res.body.code == 200) {
                this.parentAddOptions = res.body.content;
            }else if(res.body.code == 500) {
                this.$message({
                    message: res.body.msg,
                    type: 'error'
                });
            }
        })
    },
    // 编辑时选择父级ID
    onProvincesAddChange(item) {
      console.log(this.selectedAddOptions);
      for(var i = 0 ; i < item.length ; i++) {
            if(i == item.length - 1) {
                this.AddForm.c_fid = item[i];
            }
        }
      if(item.length == 0) {
        this.AddForm.c_fid = '';
      }
    },
    AddSave(formName) {
        this.$refs[formName].validate((valid) => {
            if(valid) {
                const loading = this.$loading({
                    lock: true,
                    text: '正在保存中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var formdata = new FormData();
                formdata.append('access_token',getToken());
                // formdata.append('c_haschild',this.AddForm.c_haschild);
                formdata.append('c_name',this.AddForm.c_name);
                // formdata.append('c_type',this.AddForm.c_type);
                // formdata.append('c_id',this.AddForm.c_id);
                formdata.append('c_director',JSON.stringify(this.AddForm.c_director));
                formdata.append('c_single',this.AddForm.c_single);
                // formdata.append('c_sort',this.AddForm.c_sort);
                formdata.append('c_topic',this.AddForm.c_topic);
                formdata.append('c_url',this.AddForm.c_url);
                formdata.append('c_code',this.AddForm.c_code);
                // formdata.append('c_status',this.AddForm.c_status);
                formdata.append('c_icon',this.AddForm.c_icon);
                formdata.append('c_cover',this.AddForm.c_cover);
                formdata.append('c_introduce',this.AddForm.c_introduce);
                if(this.AddForm.c_fid) {
                    formdata.append('c_fid',this.AddForm.c_fid);
                    formdata.append('c_level',this.selectedAddOptions.length + 1);
                }else {
                    formdata.append('c_fid',0);
                    formdata.append('c_level',1);
                }

                this.$http.post(`${api.dev}/p/main/category/save`,formdata,{emulateJSON: true}).then(res => {
                    if(res.body.code == 200) {
                        loading.close();
                        this.$message({
                            message: res.body.msg,
                            type: 'success'
                        });
                        this.$router.back(-1);
                    }else if (res.body.code == 500) {
                        loading.close();
                        this.$message({
                            message : res.body.msg,
                            type : 'error'
                        })
                    }
                })
            }else {
                console.log('submit error');
                return false;
            }
        })
    },
    customUploadIcon(options){   
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.AddUploadIcon.uploadFiles.splice(this.$refs.AddUploadIcon.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
                  this.AddForm.c_icon= res.body.content; 
                }  
        });       
      },
    // successAddUploadIcon(res,file,fileList) {
    //         this.AddForm.c_icon = res.content;
    //   },
      removeAddUploadIcon(file,fileList) {
            this.AddForm.c_icon = '';
      },
      customUploadCover(options){  
        //console.log(options);
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.AddUpload.uploadFiles.splice(this.$refs.AddUpload.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
                  this.AddForm.c_cover = res.body.content; 
                }  
        });       
      },
      // successAddUploadCover(res,file,fileList) {
      //       this.AddForm.c_cover = res.content;
      // },
      removeAddUploadCover(file,fileList) {
            this.AddForm.c_cover = '';
      },
      beforeUploadIcon(file) {
        const isLt5M = file.size / 1024 / 1024  < 5;
        if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的图片格式');
            return false;
        }
        if (!isLt5M) {
            this.$message.error('上传图片大小不能超过5MB!');
            return false;
        }
      },
      beforeUploadCover(file) {
        const isLt5M = file.size / 1024 / 1024  < 5;
        if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的图片格式');
            return false;
        }
        if (!isLt5M) {
            this.$message.error('上传图片大小不能超过5MB!');
            return false;
        }
      },
          // 放大图片
    handleAddPreviewCover(file) {
        this.AddPreviewDialogVisibleCover = true;
        this.AddPreviewDialogImageUrlCover = file.url;
    },
    handleAddPreviewIcon(file) {
        this.AddPreviewDialogVisibleIcon = true;
        this.AddPreviewDialogImageUrlIcon = file.url;
    }
  },
  created() {
      this.getAllTopic()
      this.getSelectAdmin()
  },
  computed: {
        uploadDisabledIcon:function() {
            return this.AddForm.c_icon != ''
        },
        uploadDisabledCover:function() {
            return this.AddForm.c_cover != ''
        },
    },
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
    margin-right -15px
form.el-form 
    width 1180px;
.columadd /deep/ textarea
    resize none

</style>
